import { ApiController } from './ApiController';
import { Endpoint } from './Endpoint';
import { cloneResourceWithPath } from './Resource';
import { __DEV__ } from '../constants/data';
const reflect = (value) => value;
const mergeClientSetup = (defaults) => (setup) => ({
    ...defaults,
    ...setup,
});
export class Client {
    constructor(url, setup = {}) {
        this.url = url;
        this.setup = mergeDefaultClientSetup(setup);
        this.controller = new ApiController(this);
    }
    /**
     * Creates an endpoint tied to the passed Resource.
     * By default, the endpoint will use the path defined in the Resource.
     * Alternatively, it's possible to provide an alternative path if the Resource is used for
     * different endpoints.
     */
    endpoint(Resource, alternativePath) {
        return new Endpoint(this, alternativePath ? cloneResourceWithPath(Resource, alternativePath) : Resource);
    }
    register(...resources) {
        if (__DEV__) {
            console.warn(`Client#register is deprecated`);
        }
    }
    toString() {
        return String(this.url);
    }
}
const windowFetch = (typeof window !== 'undefined' && typeof window.fetch === 'function'
    ? fetch.bind(window)
    : undefined);
export const mergeDefaultClientSetup = mergeClientSetup({
    createPageQuery: reflect,
    transformRelationshipForURL: reflect,
    parseErrorObject: reflect,
    beforeRequest: reflect,
    fetchAdapter: windowFetch,
});
//# sourceMappingURL=Client.js.map